import svgPaths from "./svg-v1tpk465th";

function Component() {
  return (
    <div
      className="absolute h-[1390px] left-1/2 top-1/2 translate-x-[-50%] translate-y-[-50%] w-[1524px]"
      data-name="_Режим_ізоляції"
    >
      <svg
        className="block size-full"
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 1524 1390"
      >
        <g clipPath="url(#clip0_1_360)" id="_Ð ÐµÐ¶Ð¸Ð¼_ÑÐ·Ð¾Ð»ÑÑÑÑ">
          <path
            d={svgPaths.p3f241600}
            fill="url(#paint0_radial_1_360)"
            fillOpacity="0.15"
            id="Vector"
            opacity="0.3"
          />
        </g>
        <defs>
          <radialGradient
            cx="0"
            cy="0"
            gradientTransform="translate(761.83 694.808) rotate(90) scale(761.808 761.83)"
            gradientUnits="userSpaceOnUse"
            id="paint0_radial_1_360"
            r="1"
          >
            <stop stopColor="#165BFB" />
            <stop offset="1" stopColor="#58595A" />
          </radialGradient>
          <clipPath id="clip0_1_360">
            <rect fill="white" height="1390" width="1524" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

export default function Background() {
  return (
    <div className="bg-[#ffffff] relative size-full" data-name="background">
      <Component />
    </div>
  );
}